module.exports = __webpack_public_path__ + "images/40da1bcb9dd1643d29f602bf5efed82b.png";